import { connect } from 'react-redux';
import { PROJECTS_RESOURCE_NAME } from 'explore/constants';
import { mapStateToProps as mapStateToControlsProps } from 'explore/containers/projects_controls';
import AppliedFilters from 'common/filter/containers/applied';

export const mapStateToProps = (state) => {
  const {
    industryOptions, statusOptions, timeLeftOptions, assuredOptions, galleryOptions,
    awardsOptions, subcategoryOptions
  } = mapStateToControlsProps(state);

  return {
    resourceName: PROJECTS_RESOURCE_NAME,
    options: {
      industry: industryOptions,
      status: statusOptions,
      deadline_remaining__lte: timeLeftOptions,
      assured: assuredOptions,
      private_gallery: galleryOptions,
      total_awards_and_tips: awardsOptions,
      sub_category: subcategoryOptions
    },
    fieldLabels: {
      deadline_remaining__lte: 'time left',
      assured: 'type',
      package_name: 'type',
      private_gallery: 'gallery',
      total_awards_and_tips: 'award',
      sub_category: 'sub-category'
    }
  };
}

export default connect(mapStateToProps)(AppliedFilters);



// WEBPACK FOOTER //
// ./explore/containers/projects_applied_filters.js